/*
 * VTee 商品カード画像サイクラー
 * - クリック式: プログレスバーの各セグメントをクリックして画像切替
 * - 7 個以上のとき progress コンテナを横スクロール可能にし、
 *   アクティブバーが常に見える位置に自動スクロール
 * - スワイプ対応: タッチ操作で左右スワイプで画像を切り替え
 *   (PLP では誤動作で商品ページに遷移しないようにクリック抑止)
 */
(function () {
  'use strict';

  var SWIPE_MOVE_THRESHOLD = 10;   // この距離超えで「横スワイプ中」と判定
  var SWIPE_END_THRESHOLD = 30;    // 終了時にこの距離超えなら画像切替

  function scrollBarIntoView(progressEl, bar) {
    if (!progressEl || !bar) return;
    if (progressEl.scrollWidth <= progressEl.clientWidth) return;
    var pr = progressEl.getBoundingClientRect();
    var br = bar.getBoundingClientRect();
    var margin = 24;
    if (br.left < pr.left + margin) {
      progressEl.scrollBy({ left: br.left - pr.left - margin, behavior: 'smooth' });
    } else if (br.right > pr.right - margin) {
      progressEl.scrollBy({ left: br.right - pr.right + margin, behavior: 'smooth' });
    }
  }

  function activate(cycler, index) {
    var images = cycler.querySelectorAll('.vtee-card-cycler__image');
    var bars = cycler.querySelectorAll('.vtee-card-cycler__bar');
    images.forEach(function (img) {
      img.classList.toggle('is-active', Number(img.dataset.index) === index);
    });
    var activeBar = null;
    bars.forEach(function (bar) {
      var on = Number(bar.dataset.index) === index;
      bar.classList.toggle('is-active', on);
      if (on) activeBar = bar;
    });
    var progress = cycler.querySelector('[data-vtee-cycler-progress]');
    scrollBarIntoView(progress, activeBar);
  }

  function getCurrentIndex(cycler) {
    var images = cycler.querySelectorAll('.vtee-card-cycler__image');
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function getImageCount(cycler) {
    return cycler.querySelectorAll('.vtee-card-cycler__image').length;
  }

  /*
   * スワイプを cycler.parentElement で捕捉する
   * - cycler 自身は pointer-events:none なので、親 (.card__inner / .product__media-wrapper) で listen
   * - 横方向の移動が縦より大きい場合のみ「スワイプ」と判定し、ページ縦スクロールを邪魔しない
   * - スワイプ完了後の click を capture フェーズで止めて、PLP の遷移リンクが発火しないようにする
   */
  function initSwipe(cycler) {
    // PLP カードでは商品リンクのオーバーレイ <a>(::after でカード全面を覆う, z-index:1)が
    // 実際のタッチ対象になる。この <a> は .card__content 内で .card__inner の外側にあるため、
    // cycler.parentElement(.card__inner)で listen するとタッチが届かずスワイプが効かない。
    // メディアとオーバーレイ両方を含む .card-wrapper で listen する(PDP 等は従来の親要素)。
    var parent = cycler.closest('.card-wrapper') || cycler.parentElement;
    if (!parent) return;

    var startX = 0;
    var startY = 0;
    var isHorizontalSwipe = false;
    var swipedEnoughToTrigger = false;
    var blockNextClick = false;

    function onTouchStart(e) {
      if (e.touches.length !== 1) return;
      // 対象タッチがプログレスバー上で始まったらバーのクリック扱いに任せる
      if (e.target.closest && e.target.closest('.vtee-card-cycler__bar')) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isHorizontalSwipe = false;
      swipedEnoughToTrigger = false;
    }

    function onTouchMove(e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (!isHorizontalSwipe) {
        if (Math.abs(dx) > SWIPE_MOVE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          isHorizontalSwipe = true;
        }
      }
      if (isHorizontalSwipe && e.cancelable) {
        // 横スワイプ確定: ページ横スクロール & 後続 click を抑制
        e.preventDefault();
      }
    }

    function onTouchEnd(e) {
      if (!isHorizontalSwipe) return;
      var dx = (e.changedTouches[0] || { clientX: startX }).clientX - startX;
      if (Math.abs(dx) >= SWIPE_END_THRESHOLD) {
        var count = getImageCount(cycler);
        if (count > 1) {
          var current = getCurrentIndex(cycler);
          var next = dx < 0 ? current + 1 : current - 1;
          if (next < 0) next = count - 1;
          if (next >= count) next = 0;
          activate(cycler, next);
        }
        // 後続 click を 1 回だけ抑制 (PLP のリンク遷移を防ぐ)
        blockNextClick = true;
      }
    }

    function onClickCapture(e) {
      if (blockNextClick) {
        e.preventDefault();
        e.stopPropagation();
        blockNextClick = false;
      }
    }

    parent.addEventListener('touchstart', onTouchStart, { passive: true });
    parent.addEventListener('touchmove', onTouchMove, { passive: false });
    parent.addEventListener('touchend', onTouchEnd, { passive: true });
    parent.addEventListener('touchcancel', function () {
      isHorizontalSwipe = false;
      swipedEnoughToTrigger = false;
    }, { passive: true });
    // 直後の click を capture フェーズで止める (リンク遷移防止)
    parent.addEventListener('click', onClickCapture, true);
  }

  function initCycler(cycler) {
    if (cycler.dataset.vteeCyclerInit === '1') return;
    cycler.dataset.vteeCyclerInit = '1';

    var bars = cycler.querySelectorAll('.vtee-card-cycler__bar');
    bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        activate(cycler, Number(bar.dataset.index));
      });
    });

    var navs = cycler.querySelectorAll('[data-vtee-cycler-nav]');
    navs.forEach(function (nav) {
      nav.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var count = getImageCount(cycler);
        if (count < 2) return;
        var current = getCurrentIndex(cycler);
        var direction = nav.dataset.vteeCyclerNav;
        var next = direction === 'next' ? current + 1 : current - 1;
        if (next < 0) next = count - 1;
        if (next >= count) next = 0;
        activate(cycler, next);
      });
    });

    initSwipe(cycler);
  }

  function init() {
    document.querySelectorAll('[data-vtee-cycler]').forEach(initCycler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

    /*
   * 後から差し込まれるカードにも対応する
   * - <product-recommendations> (global.js) は IntersectionObserver で fetch し、
   *   this.innerHTML = ... で中身を差し替えるが、完了イベントを出さない。
   *   そのため PDP のおすすめ商品 (related-products) のサイクラーが未初期化のままだった。
   * - 同様に facets によるコレクション絞り込みやクイックアドドロワーなど、
   *   innerHTML 差し替えでカードが増える箇所すべてを拾う。
   * initCycler は data-vtee-cycler-init で二重初期化を防いでいるので、
   * 既存カードを再度渡しても副作用はない。
   */
  function observeAddedCyclers() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('[data-vtee-cycler]')) {
            initCycler(node);
            return;
          }
          var found = node.querySelectorAll('[data-vtee-cycler]');
          if (found.length) found.forEach(initCycler);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAddedCyclers);
  } else {
    observeAddedCyclers();
  }
})();
